export const generateMetaHtml = (data: any) => {
  const domain = "https://www.benvorabioscience.com";
  // Handle canonical: if it's a full URL, use it; otherwise append to domain
  let canonicalUrl = "";
  if (data.canonical) {
    canonicalUrl = data.canonical.startsWith("http") 
      ? data.canonical 
      : `${domain}/${data.canonical.replace(/^\/+/, "")}`;
  }

  const parts = [
    data.title ? `<title>${data.title}</title>` : "",
    data.title ? `<meta name="title" content="${data.title}" />` : "",
    data.description ? `<meta name="description" content="${data.description}" />` : "",
    data.keywords ? `<meta name="keywords" content="${data.keywords}" />` : "",
    data.robots ? `<meta name="robots" content="${data.robots}" />` : "",
    data.author ? `<meta name="author" content="${data.author}" />` : "",
    data.copyright ? `<meta name="copyright" content="${data.copyright}" />` : "",
    canonicalUrl ? `<link rel="canonical" href="${canonicalUrl}" />` : "",
    
    // OG
    data.ogType ? `<meta property="og:type" content="${data.ogType}" />` : "",
    data.ogUrl ? `<meta property="og:url" content="${data.ogUrl || canonicalUrl}" />` : "",
    data.ogTitle ? `<meta property="og:title" content="${data.ogTitle || data.title}" />` : "",
    data.ogDescription ? `<meta property="og:description" content="${data.ogDescription || data.description}" />` : "",
    data.ogImage ? `<meta property="og:image" content="${data.ogImage}" />` : "",

    // Twitter
    data.twitterCard ? `<meta name="twitter:card" content="${data.twitterCard}" />` : "",
    data.twitterTitle ? `<meta name="twitter:title" content="${data.twitterTitle || data.title}" />` : "",
    data.twitterDescription ? `<meta name="twitter:description" content="${data.twitterDescription || data.description}" />` : "",
    data.twitterImage ? `<meta name="twitter:image" content="${data.twitterImage || data.ogImage}" />` : "",

    // Geo
    data.geoRegion ? `<meta name="geo.region" content="${data.geoRegion}" />` : "",
    data.geoPlacename ? `<meta name="geo.placename" content="${data.geoPlacename}" />` : "",
    data.geoPosition ? `<meta name="geo.position" content="${data.geoPosition}" />` : "",
    
    // Favicon
    data.favicon ? `<link rel="icon" type="image/png" href="${data.favicon}" />` : ""
  ];

  return parts.filter(Boolean).join("\n");
};

export const parseMetaHtml = (html: string) => {
  const extract = (regex: RegExp) => {
    const match = html.match(regex);
    return match ? match[1] : "";
  };

  const domain = "https://www.benvorabioscience.com";
  const canonicalFull = extract(/<link rel="canonical" href="([^"]+)"/);
  let canonical = canonicalFull;
  if (canonicalFull.startsWith(domain)) {
    canonical = canonicalFull.replace(domain, "").replace(/^\/+/, "");
  }

  return {
    title: extract(/<title>([^<]+)<\/title>/) || extract(/<meta name="title" content="([^"]+)"/),
    description: extract(/<meta name="description" content="([^"]+)"/),
    keywords: extract(/<meta name="keywords" content="([^"]+)"/),
    robots: extract(/<meta name="robots" content="([^"]+)"/),
    author: extract(/<meta name="author" content="([^"]+)"/),
    copyright: extract(/<meta name="copyright" content="([^"]+)"/),
    canonical: canonical,
    
    ogType: extract(/<meta property="og:type" content="([^"]+)"/),
    ogUrl: extract(/<meta property="og:url" content="([^"]+)"/),
    ogTitle: extract(/<meta property="og:title" content="([^"]+)"/),
    ogDescription: extract(/<meta property="og:description" content="([^"]+)"/),
    ogImage: extract(/<meta property="og:image" content="([^"]+)"/),

    twitterCard: extract(/<meta name="twitter:card" content="([^"]+)"/),
    twitterTitle: extract(/<meta name="twitter:title" content="([^"]+)"/),
    twitterDescription: extract(/<meta name="twitter:description" content="([^"]+)"/),
    twitterImage: extract(/<meta name="twitter:image" content="([^"]+)"/),

    geoRegion: extract(/<meta name="geo.region" content="([^"]+)"/),
    geoPlacename: extract(/<meta name="geo.placename" content="([^"]+)"/),
    geoPosition: extract(/<meta name="geo.position" content="([^"]+)"/),
    
    favicon: extract(/<link rel="icon" type="image\/png" href="([^"]+)"/)
  };
};